// @flow
import type {
	TRootStore,
} from "../../types";

export const isMenuOpen = (state: TRootStore) => state.uiMenu.open;


// WEBPACK FOOTER //
// ./src/modules/selectors/uiMenu/index.js